module.exports = __webpack_public_path__ + "img/upload_noback.2ed30d7b.svg";